import { render, staticRenderFns } from "./Churches-Single.vue?vue&type=template&id=151af7d6&"
import script from "./Churches-Single.vue?vue&type=script&lang=js&"
export * from "./Churches-Single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports